/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * BASELINE. Do not copy and paste
 *	> 'createAccessors' import from 'owa-viewstate-store' is restricted. createAccessors can cause performance problems. Create mutators by hand */
import { createAccessors } from "owa-viewstate-store";
import { createStore } from "owa-satcheljs";

import type { CalendarEvent } from "owa-graph-schema";
import type { DateRange } from "owa-datetime-utils";
const getStore = createStore("places-calendar-view-store", {
    calendarEvents: null as Map<DateRange, CalendarEvent[]> | null,
});

const dest = createAccessors("places-calendar-view-store", getStore);
const getCalendarEvents: () => Map<DateRange, CalendarEvent[]> | null = dest.getCalendarEvents;
const setCalendarEvents: (newValue: Map<DateRange, CalendarEvent[]> | null) => void = dest.setCalendarEvents;

export const addCalendarEvents = (dateRange: DateRange, events: CalendarEvent[]): void => {
    const currentEvents = getCalendarEvents() || new Map<DateRange, CalendarEvent[]>();
    currentEvents.set(dateRange, events);
    setCalendarEvents(currentEvents);
};

export { getCalendarEvents };
